/**
 * 쓰기를 순서대로 하나씩 실행하는 꼬리 체인.
 *
 * Owns:
 * - 앞 작업이 끝나기 전에는 다음 작업을 시작시키지 않는다는 규칙.
 * - 앞 작업의 실패가 뒤 작업을 막지 않는다는 규칙.
 *
 * Does not own:
 * - 무엇을 쓰는지, 실패를 어떻게 읽는지.
 *
 * 같은 커널의 쓰기와 전체 비우기 순서를 유지한다. 독립 창·탭은 이 큐를 공유하지 않는다.
 * 그래서 읽기부터 판단·커밋까지의 배타성은 `_bundle` 의 readwrite 트랜잭션이 보장한다.

 */
export class SerialTaskQueue {
  private tail: Promise<unknown> = Promise.resolve();

  run<T>(task: () => Promise<T>): Promise<T> {
    const started = this.tail.then(task);
    // 꼬리는 성공으로 정규화한다. 정규화하지 않으면 한 번의 실패로 뒤의 모든 작업이 실행되지 않는다.
    this.tail = started.then(swallow, swallow);
    return started;
  }
}

function swallow(): void {}
